export const COMPOSITE_WORKER_SCRIPT_URL = '/mockup-generator.composite.worker.js'
export const PREFIX_LOG = `[mockup-generator][composite]`
